<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-12">
                <div class='chart-row'>
                    <div id="leads-day-of-month" class='chart-column'></div>
                    <div id="calls-day-of-month" class='chart-column'></div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'activeTab',
        ],
        watch: {
            data() {
                this.refresh();
            },
            activeTab() {
                if (this.activeTab == 'day-of-month') this.refresh();
            }
        },
        methods: {
            isGoogleChartsLoaded() {
                return typeof google !== 'undefined' && google.visualization && typeof google.visualization.arrayToDataTable === 'function';
            },
            refresh() {
                if (!this.isGoogleChartsLoaded()) return;
                this.drawLeadsChart();
                this.drawCallsChart();
            },
            drawLeadsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Day of Month', '# Leads']],
                        _.map(this.data.dayOfMonth, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Leads',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('leads-day-of-month'));
                chart.draw(data, options);
            },
            drawCallsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Day of Month', '# Calls']],
                        _.map(this.data.callsDayOfMonth, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Calls',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('calls-day-of-month'));
                chart.draw(data, options);
            },
        },
    }
</script>

<style scoped>
    .chart-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 100%;
    }
    .chart-column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        min-height: 40em;
    }    
</style>
